import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const SuccessProduitPage = () => {
  return (
    <div className="flex flex-col gap-3">
      Merci pour votre achat !
      <div>
        <Link to={"/boutique"}>
          <Button>Télécharger mes étiquettes dans la boutique</Button>
        </Link>
      </div>
    </div>
  );
};

export default SuccessProduitPage;
